module.exports = __webpack_public_path__ + "static/img/snWX.cb4d1ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/snWX.jpg
// module id = E42J
// module chunks = 49